import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { searchGeneralProducts } from '../api/aliApi';

const trendingTags = ['#Tech', '#Laptops', '#Shoes', '#Watches', '#Fashion'];

const SearchSpotlight = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    const delay = setTimeout(() => {
      fetchSuggestions();
    }, 400);

    return () => clearTimeout(delay);
  }, [query]);

  const fetchSuggestions = async () => {
    setLoading(true);
    try {
      const res = await searchGeneralProducts(query, '', 1);
      const data = res?.aliexpress_ds_text_search_response?.data?.products?.selection_search_product || [];
      setSuggestions(data.slice(0, 6));
      setShowDropdown(true);
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/products?search=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-8">
          Find What You Love
        </h2>

        {/* Search Form */}
        <form onSubmit={handleSearch} className="relative mb-10">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search for anything..."
            className="w-full px-6 py-4 rounded-full shadow-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 text-gray-800 pr-14 text-base sm:text-lg"
          />

          {/* Spinner */}
          {loading && (
            <>
              <div className="absolute top-1/2 right-6 transform -translate-y-1/2">
                <svg className="animate-spin h-5 w-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z" />
                </svg>
              </div>
              <p className="absolute left-4 -bottom-6 text-sm text-green-400">
                Searching for your results, please wait...
              </p>
            </>
          )}

          {/* Suggestions */}
          {showDropdown && (
            <div className="absolute left-0 right-0 bg-white text-gray-800 rounded-md shadow-lg mt-2 max-h-80 overflow-y-auto z-30 border">
              {suggestions.length === 0 && !loading ? (
                <p className="p-3 text-sm text-center text-gray-400">No results found</p>
              ) : (
                <>
                  {suggestions.map((product, idx) => (
                    <div
                      key={idx}
                      onClick={() => navigate(`/aliproduct/${product.itemId}`)}
                      className="cursor-pointer hover:bg-gray-100 p-3 flex items-center gap-3 border-b"
                    >
                      <img
                        src={product.itemMainPic || 'https://placehold.co/50x50'}
                        alt="product"
                        className="w-12 h-12 object-cover rounded"
                      />
                      <span className="text-sm line-clamp-2">{product.title}</span>
                    </div>
                  ))}
                  <div
                    onClick={() => navigate(`/products?search=${encodeURIComponent(query)}`)}
                    className="cursor-pointer text-center text-green-600 hover:underline text-sm font-medium py-3"
                  >
                    View more results for "{query}"
                  </div>
                </>
              )}
            </div>
          )}
        </form>

        {/* Trending Tags */}
        <div className="flex flex-wrap justify-center gap-3">
          {trendingTags.map((tag, idx) => (
            <span
              key={idx}
              onClick={() => {
                setQuery(tag.replace('#', ''));
                navigate(`/products?search=${tag.replace('#', '')}`);
              }}
              className="bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium hover:bg-green-100 hover:text-green-700 cursor-pointer transition"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SearchSpotlight;
